module.exports = {
    help_center: '幫助中心',
    go_to: '回到UPlus',
    previous_page: '上一頁',
    announcement_center: '公告中心',
    welcome_to_help_center: '歡迎來到幫助中心',
    anything: '我能為你做點什麼？',
    getting_started_guide: '新手教程',
    getting_started_guide_desc: '了解在UPlus如何開啟加密貨幣交易',
    customer_service: '客服',
    customer_service_desc: '無法解決，聯繫人工客服',
    faq: '常見問題',
    faq_desc: 'Uplus使用中常見問題的說明',
    view_all: '查看全部',
    newbies_must_read: '新手必讀',
    uplus_product_introduction: 'UPlus產品介紹',
    exclusive_user_introduction: '專屬用戶介紹',
    modify_strategy_position_description: '修改策略倉位說明',
    stop_loss_instructions: '止損說明',
    points_card_and_fuel_fee_explanation: '點卡和燃料費說明',
    announcement: '公告',
    new_user_account: '新用戶開通綁定流程',
    binance_api_binding_tutorial: '幣安API綁定教程',
    ouyi_api_binding_tutorial: '歐易API綁定教程',
    understanding_gold: '秒懂黃金三角套利交易',
    understand_bb_trading_in_seconds: '秒懂BB交易',
    understand_ub_trading_in_seconds: '秒懂UB交易',
    understand_grid_trading_in_seconds: '秒懂網格策略',
    understand_martingale_strategy: '秒懂馬丁策略',
    tutorial_on: '歐易賬戶合約量化開通權限教程',
    understand_hedging_contract: '秒懂對沖合約交易',
    all_read: '全部已讀',
    transaction_notification: '交易通知',
    article: '文章',
    system_notification: '系統通知',
    details: '詳情',
	to_UPlus:'回UPlus'

}
